module.exports = __webpack_public_path__ + "img/HD_gg_logo_1_67e4455c9.png";